import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withHandlers,
  lifecycle,
  withState
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import ReactSelectMaterialUi from 'react-select-material-ui';
import GochiMenuEventDetailTable from '../../components/molecules/GochiMenuEventDetailTable';
import CloseButton from '../../components/atoms/CloseButton';
import { languages, languageType } from '../../constants/Language';

const styles = {
  root: {
    position: 'absolute',
    width: '85%',
    height: 'auto',
    maxHeight: '80%',
    top: '5%',
    left: '2%',
    backgroundColor: '#fff',
    padding: 28,
    overflow: 'scroll',
    outline: 'none'
  },
  margin: {
    margin: '20px 0 0 0'
  },
  scrollTable: {
    maxHeight: 296,
    overflowX: 'scroll',
    whiteSpace: 'nowrap'
  },
  selectControl: {
    width: '100%'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(dispatch => ({
    actions: bindActionCreators({}, dispatch)
  })),
  setPropTypes(propTypes),
  withState('isLanguage', 'setIsLanguage', 'ja'),
  withHandlers({}),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(
  ({ classes, detail, updateOpenDetailModal, isLanguage, setIsLanguage }) => {
    let { menuName, menuEventName, description } = detail;

    if (isLanguage !== languageType.ORIGIN) {
      const languageData = detail.otherLanguages.find(
        language => language.language === isLanguage
      );
      if (languageData) {
        ({ menuName, description, menuEventName } = languageData.params);
      }
    }
    const closeAction = () => updateOpenDetailModal(false);

    return (
      <div className={classes.root}>
        <Typography variant="h6">メニュー情報詳細</Typography>
        <div>
          {detail.manual !== 1 && (
            <ReactSelectMaterialUi
              required
              className={[classes.textField, classes.selectControl]}
              defaultValue={isLanguage}
              value={isLanguage}
              options={languages}
              margin="normal"
              onChange={v => {
                if (isLanguage === v) {
                  return;
                }
                setIsLanguage(v);
              }}
            />
          )}
          <GochiMenuEventDetailTable
            menuEventName={menuEventName}
            menuName={menuName}
            price={detail.price}
            taxTypeStr={detail.taxTypeStr}
            reducedTaxTypeStr={detail.reducedTaxTypeStr}
            // displayAmount={detail.displayAmount}
            premiumPercent={detail.premiumPercent}
            menuLimitTotal={detail.menuLimitTotal}
            prefectures={detail.prefectures}
            groupName={detail.groupName}
            description={description}
            manual={detail.manual}
            menuCombo={detail.menuCombo}
            tags={detail.tags}
            image={detail.image}
            gochimeshiFlag={detail.gochimeshiFlag}
            createdAt={detail.createdAt}
            updatedAt={detail.updatedAt}
            isETicket={detail.isETicket}
          />
        </div>
        <div>
          <CloseButton onClickAction={closeAction} />
        </div>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
